import {
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    Image,
    Text,
    Input,
    useDisclosure,
    Heading,
    IconButton, Box,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import EatingLocationCard from '../../components/EatingLocationCard/EatingLocationCard'
import MenuItems from './components/MenuItems/MenuItems'
import ItemEditing from './components/ItemEditing/ItemEditing'
import { useFormContext } from 'react-hook-form'
import { mapOrderProducts } from '../../../../services/product'
import { AddIcon, MinusIcon } from '@chakra-ui/icons'
import { useAppSelector } from '../../../../hooks'
import { RootState } from '../../../../store'
import { getAccount } from '../../../../services/auth'
import {calculateTotalPrice} from "../../../../services/price";
import {useTranslation} from "react-i18next";
import TacoCardBig from "./components/MenuItems/TacoCardBig";

export const SUB_MENU = {
    FOOD: 'FOOD',
    DRINK: 'DRINK',
    DESSERT: 'DESSERT',
    COMBO: 'COMBO',
    SEASONAL: 'SEASONAL',
    FIT_TACOS: 'FIT_TACOS',
    COFFEE: 'COFFEE',
    SIDE: 'SIDE',
    SAUCE_PACKAGE: 'SAUCE_PACKAGE'
}
export default ({
    food,
    drink,
    meat,
    sauce,
    topping,
    sides,
    selectItem,
    selectedItem,
    clearItem,
    dessert,
    combo,
    seasonal,
    saucePackages,
    fitTacos,
    coffees,
    changeItemQuantity,
    handleCancelOrder,
    handleConfirmOrder,
}: {
    food: any[]
    drink: any[]
    meat: any[]
    sauce: any[]
    topping: any[]
    sides: any[]
    selectItem: Function
    selectedItem: null | any
    clearItem: Function
    dessert: any[]
    combo: any[]
    seasonal: any[]
    saucePackages: any[]
    fitTacos: any[]
    coffees: any[]
    changeItemQuantity: Function
    handleCancelOrder: Function
    handleConfirmOrder: Function
}) => {
    const [selectedSubMenu, setSelectedSubMenu] = useState(SUB_MENU.FOOD)
    const [isOpen, setIsOpen] = useState(false)
    const locations = useAppSelector((state: RootState) => state.locations)
    const userAccount = getAccount();
    const {t} = useTranslation();
    const menu = locations.data.find(
        (location) => location.locationId === userAccount.location
    )
    const form = useFormContext()
    const orderItems = form.getValues('order')
    const totalPrice = calculateTotalPrice(mapOrderProducts(
        orderItems,
        locations.selectedLocation.menu || []
    ));
    return (
        <Flex
            marginTop={'auto'}
            w={'full'}
            justifyContent={'center'}
            flexDirection={'column'}
            mx={'auto'}
            alignItems={'center'}
            p={6}
        >

            <Flex gap={10} justifyContent={'center'} flexDirection={'column'} w={'full'}>
                <Flex
                    overflowX={'auto'}>
                    <Flex
                        direction={'row'}
                        whiteSpace={'nowrap'}
                        gap={5}
                        justifyContent={'center'}
                        px={3}
                        mx={'auto'}
                        width={{
                            lg: 'full'
                        }}
                    >
                        <Flex
                            flexShrink={0}
                            direction={'column'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            borderRadius={'5px'}
                            opacity={selectedSubMenu === SUB_MENU.FOOD ? 1 : 0.5}
                            bgColor={selectedSubMenu === SUB_MENU.FOOD ? 'brand.primary' : 'transparent'}
                            p={'5px'}
                        >
                            <Image
                                cursor={'pointer'}
                                src={'/images/tacos.png'}
                                height={{
                                    base:'50px',
                                    lg: '100px'
                                }}
                                width={'auto'}
                                onClick={() => setSelectedSubMenu(SUB_MENU.FOOD)}
                            />
                            <Text textAlign={'center'} fontSize={{
                                lg: 24
                            }} color={'white'}>{t('taco')}</Text>
                        </Flex>
                        {!!seasonal?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.SEASONAL ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.SEASONAL ? '#E65100' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/seasonal.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.SEASONAL)
                                    }
                                />
                                <Text textAlign={'center'}  fontSize={{
                                    lg: 24
                                }} color={'white'}>{t('seasonalTaco')}</Text>
                            </Flex>
                        )}
                        {!!fitTacos?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.FIT_TACOS ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.FIT_TACOS ? '#2E7D32' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/tacos.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.FIT_TACOS)
                                    }
                                />
                                <Text textAlign={'center'}  fontSize={{
                                    lg: 24
                                }} color={'white'}>{t('fitTaco')}</Text>
                            </Flex>
                        )}
                        {!!sides?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.SIDE ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.SIDE ? '#C89260' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/sides.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.SIDE)
                                    }
                                />
                                <Text textAlign={'center'} fontSize={{
                                    lg: 24
                                }} color={'white'}>{t('extra')}</Text>
                            </Flex>
                        )}
                        {!!saucePackages?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.SAUCE_PACKAGE ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.SAUCE_PACKAGE ? '#6F4E37' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/saucePackages.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.SAUCE_PACKAGE)
                                    }
                                />
                                <Text textAlign={'center'}  fontSize={{
                                    lg: 24
                                }} color={'white'}>{t('saucePackages')}</Text>
                            </Flex>
                        )}
                        <Flex
                            flexShrink={0}
                            direction={'column'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            borderRadius={'5px'}
                            opacity={selectedSubMenu === SUB_MENU.DRINK ? 1 : 0.5}
                            bgColor={selectedSubMenu === SUB_MENU.DRINK ? '#3ca3f8' : 'transparent'}
                            p={'5px'}
                        >
                            <Image
                                cursor={'pointer'}
                                src={'/images/drinks.png'}
                                height={{
                                    base:'50px',
                                    lg: '100px'
                                }}
                                width={'auto'}
                                onClick={() => setSelectedSubMenu(SUB_MENU.DRINK)}
                            />
                            <Text textAlign={'center'} fontSize={{
                                lg: 24
                            }} color={'white'}>{t('drinks')}</Text>
                        </Flex>
                        {!!coffees?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.COFFEE ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.COFFEE ? '#6F4E37' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/coffee.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.COFFEE)
                                    }
                                />
                                <Text textAlign={'center'}  fontSize={{
                                    lg: 24
                                }} color={'white'}>{t('coffees')}</Text>
                            </Flex>
                        )}
                        {!!dessert?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.DESSERT ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.DESSERT ? '#C860BA' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/dessert.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.DESSERT)
                                    }
                                />
                                <Text textAlign={'center'} fontSize={{
                                    lg: 24
                                }}  color={'white'}>{t('dessert')}</Text>
                            </Flex>
                        )}
                        {!!combo?.length && (
                            <Flex
                                flexShrink={0}
                                direction={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                borderRadius={'5px'}
                                opacity={
                                    selectedSubMenu === SUB_MENU.COMBO ? 1 : 0.5
                                }
                                bgColor={selectedSubMenu === SUB_MENU.COMBO ? '#7AC860' : 'transparent'}
                                p={'5px'}
                            >
                                <Image
                                    cursor={'pointer'}
                                    src={'/images/combo.png'}
                                    height={{
                                        base:'50px',
                                        lg: '100px'
                                    }}
                                    width={'auto'}
                                    onClick={() =>
                                        setSelectedSubMenu(SUB_MENU.COMBO)
                                    }
                                />
                                <Text textAlign={'center'} fontSize={{
                                    lg: 24
                                }} color={'white'}>{t('combo')}</Text>
                            </Flex>
                        )}


                    </Flex>
                </Flex>

                <Flex  maxW={'600px'} mx={'auto'} w={'full'}>
                    {selectedSubMenu === SUB_MENU.FOOD && (
                        <Flex flexDirection={'column'}>
                            {/*<Box textAlign={'center'} color={'brand.primary'} position={'relative'} style={{transform: 'rotate(-10deg)'}} mb={'50px'}>{t('createYourTaco')}</Box>*/}
                            <TacoCardBig handleSelectItem={selectItem} items={food} />
                        </Flex>

                    )}
                    {selectedSubMenu === SUB_MENU.DRINK && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={drink}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.COFFEE && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={coffees}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.SAUCE_PACKAGE && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={saucePackages}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.DESSERT && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={dessert}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.COMBO && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={combo}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.SEASONAL && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={seasonal}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.FIT_TACOS && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={fitTacos}
                        />
                    )}
                    {selectedSubMenu === SUB_MENU.SIDE && (
                        <MenuItems
                            handleSelectItem={selectItem}
                            items={sides}
                        />
                    )}
                </Flex>
            </Flex>
            <Flex mt={{
                base: 5,
                lg: '100px'
            }} justifyContent={'space-between'} flexDirection={'column'} mx={'auto'} w={'full'}
                  maxW={{base: '500px', lg: '85%'}}>

                <Button
                    bgColor={'brand.primary'}
                    onClick={() => setIsOpen(true)}
                    isDisabled={!orderItems.length}
                    mb={3}
                    height={{
                        base: 20,
                        lg: 48
                    }}
                    borderRadius={{
                        base: 'md',
                        lg: '50px'
                    }}
                    fontSize={{
                        lg: 40
                    }}
                >
                    {t('viewOrder')}
                </Button>

                <Button onClick={() => handleCancelOrder()}
                        fontSize={{
                            lg: 40
                        }}
                        borderRadius={{
                            base: 'md',
                            lg: '50px'
                        }}
                        bgColor={'transparent'} color={'darkGray'} height={{
                    base: 20,
                    lg: 48
                }}>
                    {t('cancelOrder')}
                </Button>
            </Flex>
            {!!selectedItem && (
                <ItemEditing
                    name={`order.${orderItems.length}`}
                    item={selectedItem}
                    itemType={selectedItem?.productType || ''}
                    closeModal={clearItem}
                    meat={meat}
                    sauce={sauce}
                    topping={topping}
                    sides={sides}
                    drinks={drink}
                    closeModalAndSave={() => selectItem(null)}
                />
            )}
            <Drawer
                isOpen={isOpen}
                placement="right"
                onClose={() => setIsOpen(false)}
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton tabIndex={-1} />
                    <DrawerHeader>{t('yourOrder')}</DrawerHeader>

                    <DrawerBody>
                        <Flex
                            className={'w-full'}
                            justifyContent={'center'}
                            flexDirection={'column'}
                            max-w={'50%'}
                            mx={'auto'}
                        >
                            <Image
                                src={'/images/logo.png'}
                                mx={'auto'}
                                mb={5}
                            />
                            <Heading as={'h4'} mb={10}>
                                {/*{t('yourOrder')}*/}
                            </Heading>
                            <Flex
                                justifyContent={'space-around'}
                                flexWrap={'wrap'}
                                flexDirection={'column'}
                            >
                                {mapOrderProducts(
                                    orderItems,
                                    locations.selectedLocation.menu
                                ).map((orderItem: any, itemIndex:number) => (
                                    <Flex
                                        flexDirection={'column'}
                                        borderBottom={'1px'}
                                        mb={4}
                                        pb={2}
                                    >
                                        <Flex
                                            alignItems={'center'}
                                            justifyContent={'space-between'}
                                        >
                                            <Flex alignItems={'center'}>
                                                <Image
                                                    src={
                                                        orderItem?.item
                                                            ?.image
                                                    }
                                                    height={'50px'}
                                                    mr={4}
                                                />{' '}
                                                <Text>
                                                    {t(orderItem?.item?.name)}
                                                </Text>
                                            </Flex>
                                            <Flex alignItems={'center'}>
                                                <IconButton
                                                    boxSize={6}
                                                    isRound={true}
                                                    colorScheme="blue"
                                                    aria-label="Decrease quantity"
                                                    onClick={() => {
                                                        changeItemQuantity(
                                                            itemIndex,
                                                            -1
                                                        )
                                                    }}
                                                    icon={<MinusIcon />}
                                                />
                                                <Text p={3}>
                                                    {orderItem.quantity}
                                                </Text>

                                                <IconButton
                                                    boxSize={6}
                                                    isRound={true}
                                                    colorScheme="blue"
                                                    aria-label="Increase quantity"
                                                    onClick={() => {
                                                        changeItemQuantity(
                                                            itemIndex,
                                                            +1
                                                        )
                                                    }}
                                                    icon={<AddIcon />}
                                                />
                                            </Flex>
                                        </Flex>
                                        <Flex pl={4} flexDirection={'column'}>
                                            {orderItem.extras.map(
                                                (extra: any) => (
                                                    <Flex alignItems={'center'}>
                                                        <Image
                                                            src={extra.image}
                                                            height={'25px'}
                                                            mr={4}
                                                        />{' '}
                                                        <Text>
                                                            {t(extra.name)}
                                                        </Text>
                                                    </Flex>
                                                )
                                            )}
                                        </Flex>
                                    </Flex>
                                ))}
                            </Flex>
                            <Heading as={'h5'} mb={32}>
                                {t('totalToPay')} {totalPrice} {t('mkd')}
                            </Heading>
                        </Flex>
                    </DrawerBody>

                    <DrawerFooter>
                        <Flex mb={'50px'} justifyContent={'space-between'}
                              width={{
                                  lg: 'full'
                              }} flexDirection={{
                            lg: 'column-reverse'
                        }}>
                            <Button
                                variant="outline"
                                mr={{
                                    smToLg: 3,
                                    lg: 0
                                }}
                                p={2}
                                onClick={() => setIsOpen(false)}

                                borderRadius={{
                                    base: 'md',
                                    lg: '50px'
                                }}
                                height={{
                                    base: 12,
                                    lg: 24
                                }}
                                fontSize={{
                                    lg: 36
                                }}
                                width={{
                                    lg: 'full'
                                }}
                            >
                                {t('close')}
                            </Button>
                            <Button
                                bgColor={'brand.primary'}
                                isDisabled={!orderItems.length}
                                onClick={() => handleConfirmOrder()}
                                tabIndex={1}
                                borderRadius={{
                                    base: 'md',
                                    lg: '50px'
                                }}
                                minH={{
                                    base: 12,
                                    lg: 24
                                }}
                                fontSize={{
                                    lg: 36
                                }}
                                width={{
                                    lg: 'full'
                                }}
                                mb={{
                                    smToLg: 0,
                                    lg: 3
                                }}
                                p={2}
                                whiteSpace={'normal'}
                                wordBreak={'break-word'}
                            >
                                {t('makeOrder')}
                            </Button>
                        </Flex>

                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
        </Flex>
    )
}
